import { devProxyResolve } from '@tb-core/helpers/browser/dev-proxy-resolve';
import Fetch from '@tb-core/helpers/fetch';
import { storeNationalId } from '@tb-core/helpers/next-env';
import { nextUserUrl } from '@tb-core/next/api/urls';

export default async function getUser(store = storeNationalId) {
    let res: Response;

    try {
        res = await Fetch({
            host: '',
            url: devProxyResolve(nextUserUrl, { store })
        });
    } catch (e) {
        console.error('User request failed!', e);
        // @TODO Define return type.
        return {};
    }

    if (!res.ok) {
        // @TODO Define return type.
        return {};
    }

    // @TODO Define return type.
    return res.json();
}
